"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debugger = void 0;
const events_1 = require("events");
const types_1 = require("../types");
const IN_MEMORY_LOGS_MAX_LENGTH_DEFAULT = 50;
const getDebugReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (key.startsWith("_")) {
            return;
        }
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
const serializeDebugArgs = (obj) => {
    if (obj === undefined || obj === null) {
        return "";
    }
    if (typeof obj !== "object") {
        return obj.toString();
    }
    return JSON.stringify(obj, getDebugReplacer(), 2);
};
class Debugger {
    constructor(shouldLog = true, eventEmitter = new events_1.EventEmitter(), inMemoryLogsMaxLength = IN_MEMORY_LOGS_MAX_LENGTH_DEFAULT) {
        this.shouldLog = shouldLog;
        this.eventEmitter = eventEmitter;
        this.inMemoryLogsMaxLength = inMemoryLogsMaxLength;
        this.error = ({ title = "Debugger", args }) => {
            this._logger({ title, args, level: "error" });
        };
        this.warn = ({ title = "Debugger", args }) => {
            this._logger({ title, args, level: "warn" });
        };
        this.info = ({ title = "Debugger", args }) => {
            this._logger({ title, args, level: "info" });
        };
        this.debug = ({ title = "Debugger", args }) => {
            this._logger({ title, args, level: "debug" });
        };
        this._inMemoryLogs = [];
        this._logger = ({ title = "Debugger", args, level = "debug" }) => {
            const inMemoryLog = {
                title,
                args,
                level,
                timestamp: +new Date()
            };
            this.inMemoryLogs.push(inMemoryLog);
            this.eventEmitter.emit(types_1.CustomEvents.debugger, inMemoryLog);
            if (!this.shouldLog || !console[level])
                return;
            console[level](`${new Date().toISOString()} [${title}] ${serializeDebugArgs(args)}`);
        };
        if (!inMemoryLogsMaxLength || typeof inMemoryLogsMaxLength !== "number") {
            this.inMemoryLogsMaxLength = IN_MEMORY_LOGS_MAX_LENGTH_DEFAULT;
        }
        else {
            this.inMemoryLogsMaxLength = inMemoryLogsMaxLength;
        }
    }
    get inMemoryLogs() {
        return this._inMemoryLogs;
    }
    set inMemoryLogs(inMemoryLogs) {
        this._inMemoryLogs = inMemoryLogs.slice(inMemoryLogs.length -
            Math.min(inMemoryLogs.length, this.inMemoryLogsMaxLength), inMemoryLogs.length);
    }
}
exports.Debugger = Debugger;
//# sourceMappingURL=debugger.js.map